<!-- 预付款申请数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                          :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 是否有订单 -->
                                                <el-switch class="form_codition" v-if="formOneValue.entityField == 'isOrder'" title="switch" @change="changeOrder" :disabled="isChange" v-model="isShowDetail">
                                                </el-switch>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'conmId'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1 || isShowDetail == true">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1 || isShowDetail == true">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1 || isShowDetail == false">
                                                        <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1 || isShowDetail == false">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'sbiName'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.entityField == 'settleMethod'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1 || isShowDetail == true">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1 || isShowDetail == true">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- applyTime -->
                                                <el-date-picker class="form_codition" v-else-if="formOneValue.entityField == 'applyTime'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期"
                                                                format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                                                <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                                                         :isdisabled="formOneValue.isChange == 0 || isShowDetail == true" :isShowLong="false"></df-date>
                                                <!-- 订单编号 -->
                                                <!-- <el-input clearable v-else-if="formOneValue.entityField == 'psomId'" :disabled="formOneValue.isChange == 0 || isShowDetail == false" v-model.trim="sendDataInfo[formOneValue.entityField]"
                        @focus="openExComponents(formOneValue.extractId, 0, 'psomId')"></el-input> -->
                                                <!-- 预付款总金额 -->
                                                <el-input class="form_codition" clearable @input="setMoney(scope.row.jurconfigform)" v-else-if="formOneValue.entityField == 'payMoney'"
                                                          @keyup.enter.native="nextFocus(formOneKey)" :disabled="formOneValue.isChange == 0 || isShowDetail == true"
                                                          v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <!-- <el-input class="form_codition" clearable v-else-if="formOneValue.entityField == 'bankinfo'" type="textarea" :disabled="formOneValue.isChange == 0"
                          @keyup.enter.native="nextFocus(formOneKey)"
                          v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input> -->
                                                <el-input class="form_codition" clearable v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)"
                                                          v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <div style="display: flex;">
                                                    <el-button type="primary" plain @click="toBank">新增银行信息</el-button>
                                                    <el-button v-if="tabForm[0].isExtract == 1" @click="openExtSearch('9179457088430090')" size="mini" type="primary">提取外部订单</el-button>
                                                </div>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                          v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <span v-if="formOneValue.fieldType == 'date'">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}</span>
                                                <span v-else-if="formOneValue.entityField == 'isOrder'">{{
                          sendDataInfo[formOneValue.entityField]
                          == 0 ? '否' : '是' }}</span>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                            sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini" v-if="isShowDetail">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="dataActionBox.actionType > 0 || sendDataInfo.preapplyDetails.length == 0">
                                                删除</el-button>
                                        </div>
                                        <el-table :data="sendDataInfo.preapplyDetails" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                                  @selection-change="handleSelectionChange" size="mini" border style="width: 100%" :height="mxHeight">
                                            <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" :min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField" show-overflow-tooltip :label="formOneValue.showField"
                                                             v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="scope.row[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                                        <span v-if="scope.row[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField], true) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                              scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <!-- 数量 -->
                                                    <el-input @input="calculatePrice(1, scope.$index)" type="number" :min="0" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-else-if="formOneValue.entityField == 'ppadNum' && dataActionBox.actionType != 2"
                                                              v-model="sendDataInfo.preapplyDetails[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <!-- 金额 -->
                                                    <el-input @input="calculatePrice(2, scope.$index)" type="number" :min="0" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                              v-else-if="formOneValue.entityField == 'ppadMoney' && dataActionBox.actionType != 2"
                                                              v-model="sendDataInfo.preapplyDetails[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <span v-else-if="formOneValue.entityField == 'bgmId'">{{
                            sendDataInfo.preapplyDetails[scope.$index].bgmName }}</span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.preapplyDetails[formOneValue.riftField])">{{
                              sendDataInfo.preapplyDetails[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>
                                                        {{ sendDataInfo.preapplyDetails[scope.$index][formOneValue.entityField] }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>

        </div>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" top="1vh">
            <psReturnExtractionScheme ref="psReturnExtractionScheme" :extractData="extractData1" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="sendDataInfo" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import psReturnExtractionScheme from "../byComponents/psReturnExtractionScheme.vue";
export default {
    name: "purchasePaymentApplyAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        psReturnExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            form: {},
            selectedDetails: [],
            selectedDetailsIndex: 0,
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            editDateilsIndex: "",
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            ppId: "orderId",
            isShowDetail: false,
            isChange: false,
            mxHeight: 0,
            parentSearchData: {
                smId: "",
            },
            isBuyer: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            sField: '',
            selectedRow: [], // 当前已选择行
            seIndex: 0,
            //--------------
            showDialog: false,
            dialogList: [],


        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.preapplyDetails": {
            handler: function (newValue, oldValue) {
                if (this.isShowDetail) {
                    this.sendDataInfo.totalNumber = 0;
                    this.sendDataInfo.totalMoney = 0;
                    this.sendDataInfo.totalCount = this.sendDataInfo.preapplyDetails.length;
                    this.sendDataInfo.preapplyDetails.forEach(item => {
                        this.sendDataInfo.totalMoney = NP.plus(this.sendDataInfo.totalMoney, item.ppadMoney)
                    })
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, this.sendDataInfo.totalMoney)
                    this.sendDataInfo.payMoney = this.$common.getDecimalInfo(3, this.sendDataInfo.totalMoney)
                }
            },
            deep: true,
        },
        "sendDataInfo.smName": {
            handler: function (newValue, oldValue) {
                // this.sendDataInfo.depId = "";
                // this.sendDataInfo.depName = "";
                if (newValue == '') {
                    this.sendDataInfo.salesId = "";
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.sbiName = "";
                    this.sendDataInfo.sbiNumber = "";
                    this.sendDataInfo.sbiId = "";
                    this.sendDataInfo.sbiCode = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        tabHeight(val) {
            this.mxHeight = val
        },
        // 计算价格
        calculatePrice(cate, index) {
            var info = this.sendDataInfo.preapplyDetails[index];
            switch (cate) {
                case 1: // 输入数量计算金额
                    if (NP.minus(info.psodPacknum, info.oldPpadNum) < info.ppadNum) {
                        this.sendDataInfo.preapplyDetails[index].ppadNum = NP.minus(info.psodPacknum, info.oldPpadNum)
                    }
                    this.sendDataInfo.preapplyDetails[index].ppadMoney = this.$common.getDecimalInfo(3, NP.times(info.ppadNum, info.psprice))
                    break;
                case 2: // 输入金额计算数量
                    if (NP.minus(info.psmoney, info.oldPpadMoney) < info.ppadMoney) {
                        this.sendDataInfo.preapplyDetails[index].ppadMoney = NP.minus(info.psmoney, info.oldPpadMoney)
                    }
                    this.sendDataInfo.preapplyDetails[index].ppadNum = this.$common.getDecimalInfo(3, NP.divide(info.ppadMoney, info.psprice))
                    break;
            }
        },
        //his.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
        //触发提取
        openExtSearch(id) {
            this.extractData1 = {
                id: id,
                ppId: this.ppId,
                idType: "",
            };
            this.DialogExtract = true;
        },
        getWidth1(e) {
            this.exWidth1 = e + "%";
        },
        getExtractName1(e) {
            this.exTitle1 = e;
        },
        async getMoney() {
            let sendData = {
                opmId: this.sendDataInfo.opmId,
                unitId: this.sendDataInfo.smId,
                salesId: this.sendDataInfo.salesId,
                coId: this.sendDataInfo.coId,
                ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId
            }
            var responseData = await this.$http.shipPlanAddLoading(sendData);
            if (responseData.status == 200) {
                let res = responseData.result
                this.sendDataInfo.prepaySum = res.prepaySum
                this.sendDataInfo.paySum = res.paySum
                console.log(this.sendDataInfo.prepaySum, this.sendDataInfo.paySum)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        toBank() {
            this.$parent.$parent.toSalesman()
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        changeOrder(e) {
            for (let key in this.sendDataInfo) {
                if (key == "preapplyDetails") {
                    this.sendDataInfo[key] = [];
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            // if (e == false && this.dataActionBox.actionType == 1) this.checkIsBuyer();
            this.sendDataInfo.applyTime = this.$moment().valueOf();
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            const arrList = [
                {
                    id: 'coId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'coName')].isShow
                }, {
                    id: 'smId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'smName')].isShow
                }, {
                    id: 'opmId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'opmName')].isShow
                }, {
                    id: 'salesId',
                    value: this.form[this.form.findIndex(item => item.entityField == 'salesName')].isShow
                }].filter(item => item.value).map(item => 'this.sendDataInfo.' + item.id + " != ''")
            this.$nextTick(() => {
                if (eval(arrList.join('&&'))) {
                    this.getMoney()
                }
                this.nextFocus(this.seIndex)
            })
        },
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp) //创建监听键盘事件
                if (this.seType == 'smName') {
                    this.$http
                        .checkVendorLicense({
                            //校验购进单位
                            formId: this.formDataList[0].jciId, //表单ID
                            unitId: val.smId, //单位ID
                        })
                        .then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                let flag = -1
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    this.parentSearchData.smId = val.smId;
                                    this.sendDataInfo.smName = val.smName;
                                    this.sendDataInfo.smId = val.smId;
                                    this.$http.queryDefaultSales({
                                        ids: [val.smId]
                                    }).then((res) => {
                                        if (res && res.status == 200) {
                                            var valObj = {
                                                ...val,
                                                ...res.result,
                                            }
                                            if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                                this.$http.checkSalesLicense({
                                                    //校验供应商业务员
                                                    formId: this.formDataList[0].jciId, //表单ID
                                                    salesId: valObj.salesId, //业务员ID
                                                }).then((res) => {
                                                    if (res && res.status == 200) {
                                                        let flag = -1;
                                                        if (res.result != null && res.result.length > 0) {
                                                            res.result.forEach(item => {
                                                                this.dialogList.push(item)
                                                            })
                                                            flag = this.dialogList.findIndex(
                                                                (item) => item.level == 0
                                                            );
                                                            this.showDialog = true;
                                                        }
                                                        if (flag == -1) {
                                                            this.paramValue(valObj);
                                                        }
                                                    } else {
                                                        this.lineMessageBox(res);

                                                        return false;
                                                    }
                                                }).catch((rej) => {
                                                    this.lineMessageBox(rej);
                                                });
                                            } else {
                                                this.paramValue(val);
                                            }
                                        } else {
                                            this.paramValue(val);
                                        }
                                    }).catch((rej) => {
                                        this.lineMessageBox(rej);
                                    });
                                } else {
                                    this.showDialog = true
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.parentSearchData.smId = "";
                                this.clearValue();
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            this.parentSearchData.smId = "";
                            this.clearValue();
                        });
                } else if (this.seType == 'coName' || this.seType == 'conmId') {
                    this.parentSearchData.smId = val.smId
                    this.paramValue(val)
                } else {
                    this.paramValue(val)
                }

            }
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        setMoney(jurconfigform) {
            const index = jurconfigform.findIndex(item => item.entityField == 'sxf')
            if (jurconfigform[index].isShow) {
                this.$http.feeDeduction({
                    payMoney: this.sendDataInfo.payMoney
                }).then(res => {
                    if (res.status == 200) {
                        this.sendDataInfo.sxf = res.result
                    }
                })
            }
        },
        onInput() {
            this.$forceUpdate();
        },
        async getDataByChen(val) {
            if (val != "" || val != undefined) {
                if (typeof val.isOrder != 'undefined' && parseFloat(val.isOrder) > -1) {
                    this.isShowDetail = val.isOrder == 1 ? true : false;
                }
                this.sendDataInfo.preapplyDetails = []
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        for (const key1 in val.arrlistbychen) {
                            this.$set(this.sendDataInfo.preapplyDetails, key1, val.arrlistbychen[key1])
                            for (const key2 in val.arrlistbychen[key1]) {
                                this.$set(this.sendDataInfo.preapplyDetails[key1], key2, val.arrlistbychen[key1][key2])
                            }
                        }
                    } else {
                        this.$set(this.sendDataInfo, key, val[key])
                        this.parentSearchData.smId = val.smId;
                    }
                }
                this.sendDataInfo.preapplyDetails.forEach((item) => {
                    item.ppadNum = this.$common.getDecimalInfo(1, (item.psodPacknum - item.oldPpadNum));
                    // item.ppadNum = (item.psodPacknum - item.oldPpadNum).toFixed(6);
                    item.ppadMoney = this.$common.getDecimalInfo(3, (item.psmoney - item.oldPpadMoney));
                    // item.ppadMoney = (item.psmoney - item.oldPpadMoney).toFixed(2);
                });
                this.DialogExtract = false;
                addEventListener('keyup', this.keyUp) //创建监听键盘事件
                if (this.isShowDetail) {
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = 0
                        console.log(this.$refs.mxTableRef);
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable && refsElTable.clearSelection();
                        refsElTable && refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this
                            .selectedDetailsIndex]);
                        this.nextFocus(this.seIndex)
                    })
                }
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 1; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            setTimeout(() => {
                this.showDialog = false
            }, 100)
            if (type == "salesName" || type == "sbiName") {
                if (this.sendDataInfo.smId == "") {
                    return this.$message({
                        message: "请先选择购进单位",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener('keyup', this.keyUp)
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type];
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            this.inputel = el ? el.getElementsByTagName('input') : ''
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.preapplyDetails.length > 0) {
                    this.tableNextFocus('ppadNum', this.selectedDetailsIndex)
                }
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },

        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == '') return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.preapplyDetails.length - 1) return
                if (this.sendDataInfo.preapplyDetails[index + 1] != undefined) {
                    this.$refs['ppadNum'][index + 1].focus() //跳预付数量
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this
                            .selectedDetailsIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.preapplyDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.preapplyDetails.length -
                        1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this
                        .selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this
                            .selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this
                        .selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.preapplyDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.preapplyDetails.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this
                        .selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this
                            .selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this
                        .selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp) //创建监听键盘事件
        },
        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 提取方案Id, 索引(表格中), 标识
        openExComponents(eId, index, type) {
            this.DialogExtract = true;
            removeEventListener('keyup', this.keyUp)
            this.exId = eId;
            this.seIndex = index;
            this.seType = type;
            this.ppId = "psomId";
            this.extractData1 = {
                id: this.exId,
                ppId: this.ppId,
                idType: "",
            };
        },
        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.rgamPurchaser) {
                    this.sendDataInfo.rgamSapdept = item.depId;
                    this.sendDataInfo.rgamSapdeptName = item.depName;
                }
            });
        },

        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$common.delOrderInfo(this.sendDataInfo.psomId)
                    this.dataActionBox.actionType = 0;
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消关闭'
                    // });
                });
        },
        initForm(sendDataInfo) {
            this.$refs.sendDataInfo.resetFields();
        },
        init() {
            console.log(this.sendDataInfo, "*****", this.tabForm)
            for (let key in this.sendDataInfo) {
                if (key == "preapplyDetails") {
                    this.sendDataInfo[key] = [];
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.tabForm[0].jurconfigform.forEach(item => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this.sendDataInfo[item.entityField] = item.defaultValue
                }
            })
            this.sendDataInfo.preapplyDetails = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
        // 提取采购退货草稿
        async extractData(data) {
            if (data.length >= 1) {
                var sendData = [];
                data.forEach((items) => {
                    sendData.push(items.psbkdId);
                });
                let responseData = await this.$http.extractPurchaseListOrder({
                    ids: sendData,
                });
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result;
                    this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },

        async isShowData(name, value) {
            console.log(name);
            switch (name) {
                case "businessGoods":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.preapplyDetails.push({
                            bgmId: dataInfo.bgmId,
                            bgmName: dataInfo.bgmName,
                            packingInfo: packingInfo,
                            batchNumber: "",
                            cartonSize: "",
                            condId: 0,
                            unitPrice: 0,
                            bgfIntaxrate: dataInfo.busgoodfinance.bgfIntaxrate,
                            originalOrderAmount: 0,
                            packingUnit: "",
                            producedData: "",
                            remark: "",
                            returnAmount: 0,
                            rgdReserves1: "",
                            rgdReserves2: "",
                            rgdReserves3: "",
                            rgdReserves4: "",
                            rgdReserves5: "",
                            rgdReserves6: "",
                            taxAmount: 0,
                            taxPrice: 0,
                            validityData: "",
                        });
                    }
                    break;

                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.rgamRapcus = dataInfo.smId;
                        this.sendDataInfo.rgamRapcusName = dataInfo.smName;
                    }
                    console.log(dataInfo);
                    break;

                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    console.log(dataInfo);
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisorderauxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisorderauxinf.coName = dataInfo.coName;
                    }

                    break;
            }
        },

        openBox() {
            console.log("==", this.actionData);
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            if (this.actionData.form) {
                this.form = this.actionData.form
            }
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField()
            this.init();
            this.getSpecialUser();
            this.getPartDictionariesData();
            this.sendDataInfo.applyTime = this.$moment().valueOf();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.isChange = false;
                // this.checkIsBuyer()
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                this.isChange = true;
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])

                }
                this.sendDataInfo.preapplyDetails = oldData.preapplydetailVos;
                this.parentSearchData.smId = oldData.smId
                if (this.sendDataInfo.isOrder == 1) {
                    this.isShowDetail = true;
                } else if (this.sendDataInfo.isOrder == 0) {
                    this.isShowDetail = false;
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])

                }
                this.sendDataInfo.preapplyDetails = oldData.preapplydetailVos;
                if (this.sendDataInfo.isOrder == 1) {
                    this.isShowDetail = true;
                } else if (this.sendDataInfo.isOrder == 0) {
                    this.isShowDetail = false;
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    if (this.isShowDetail == true && this.sendDataInfo.preapplyDetails.length <= 0) {
                        this.$message({
                            message: "明细不能为空",
                            type: "error",
                        });
                        return false;
                    }
                    this.sub();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        async sub() {
            if (this.isShowDetail == false) {
                this.sendDataInfo.preapplyDetails = [];
                this.sendDataInfo.isOrder = 0;
            } else {
                this.sendDataInfo.isOrder = 1;
            }
            console.log(this.sendDataInfo);
            if (this.dataActionBox.actionType == 0) {
                let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
                // sendData.preapplyDetails.forEach((item) => {
                //   item.ppadNum = Number(item.ppadNum) + Number(item.oldPpadNum);
                // });
                var responseData = await this.$http.addPaymentApply(sendData);
            } else {
                let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
                var responseData = await this.$http.upDatePaymentApply(sendData);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
                this.initForm("sendDataInfo");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        deleteDetails(index) {
            this.sendDataInfo.preapplyDetails.splice(this.selectedDetailsIndex, 1);
            this.$nextTick(() => {
                if (this.sendDataInfo.preapplyDetails.length > 1) {
                    this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                    this.tableNextFocus('ppadNum', this.selectedDetailsIndex)
                } else {
                    this.selectedDetailsIndex = 0
                }
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.preapplyDetails[this.selectedDetailsIndex]);
            })
            return this.$message({
                message: "删除成功",
                type: "success",
            });
        },

        // 获取供货员
        async getSpecialUser() {
            let responseData = await this.$http.getSpecialUser({
                opmBuyer: 1
            });
            if (responseData.status == 200) {
                this.userOneList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [20, 21],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 判断是不是采购员
        checkIsBuyer() {
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmBuyer == 1) {
                this.isBuyer = 1;
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
                this.tabForm[0].jurconfigform.forEach(item => {
                    if (item.entityField == 'opmName' || item.entityField == 'depName') item.isChange = 0
                })
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                        .jurconfigform[index])
                }
            })
            var arr = [{ entityField: "preapplyDetails" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            // this.checkIsBuyer();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        addEventListener('keyup', this.keyUp) //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.mb {
    margin-bottom: 0;
}

.newInput {
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
</style>